import { useState } from 'react'

const useContactAddressShared = (
  isCategory: 'personal' | 'shared' = 'personal',
) => {
  const [category, setCategory] = useState<'personal' | 'shared'>(isCategory)

  return {
    category,
    setCategory,
  }
}

export default useContactAddressShared
